<div class="form-group">
  <img *ngIf="loadingFinished && !failedToLoadImage"
       class="img-fluid"
       [src]="model.imageBase64Data">
  <div *ngIf="!loadingFinished || failedToLoadImage"
    class="image-placeholder">
  </div>
</div>
